import { useId } from 'react'
import { Icon } from '@cb/apricot-react'

function ModalHeader({ isDismissable, headerId, title }) {
  const modalHeaderId = headerId ?? useId()
  return (
    <div className={`cb-modal-header${isDismissable ? ' cb-modal-has-close' : ''}`}>
      <h2 className="cb-modal-title" id={`apricot_modal_header_${modalHeaderId}`}>
        {title}
      </h2>
      {isDismissable ? (
        <button
          type="button"
          className="cb-btn cb-btn-square cb-btn-greyscale cb-btn-close"
          aria-describedby={`apricot_modal_header_${modalHeaderId}`}
          data-cb-modal-close="true"
        >
          <span />
          <Icon name="x-mark" />
          <span className="sr-only">Close Modal</span>
        </button>
      ) : null}
    </div>
  )
}

export default ModalHeader
